$(function () {
    if ($('main').hasClass('project')) {
        $(window).on('load', function () {
            $('#twocont').twentytwenty({
                default_offset_pct: 0.7,
                no_overlay: true,
                move_slider_on_hover: true,
                move_with_handle_only: true,
                click_to_move: false
            })
        })

        var thanksClient = new SmModal({
            modalSelector: '#thanksClient',
            backgroundBlur: true,
            backgroundBlurValue: '10px',
            overlay: 'background-color: rgba(36, 43, 47, 0.75)'
        })

        $('.thanks-letter').on('click', function (e) {
            e.preventDefault()
            document
                .querySelector('#thanksClient img')
                .setAttribute(
                    'src',
                    this.getAttribute('data-img') ?? '/img/project/letter.png'
                )

            thanksClient.openModal()
        })

        // var sticky = new Sticky('.project-main__left-wp');

        // Кастомный стики

        $(window).on('load resize scroll', function (e) {
            var fixEl = $('.project-main__left-cont'),
                parEl = fixEl.parent(),
                clidEl = $('.project-main__left-cont .project-main__left-wp'),
                deltaTop =
                    window.pageYOffset + window.innerHeight >
                    $('footer').offset().top
                        ? window.pageYOffset +
                          window.innerHeight -
                          $('footer').offset().top
                        : 0,
                topPos = Number(parEl.css('paddingTop').replace('px', '')),
                leftPos = Number(parEl.css('paddingLeft').replace('px', '')),
                // rightPos = Number(parEl.css('paddingRight').replace('px', '')),
                elWidth = parEl.width()

            // console.log(parEl.offset().top + parEl.height());
            // console.log(window.pageYOffset);

            // console.log(topPos + (window.innerHeight - clidEl.height() - (window.pageYOffset + window.innerHeight - $('footer').offset().top)));

            if ($(window).width() > 1366) {
                topPos = topPos - deltaTop

                if (
                    window.pageYOffset > parEl.offset().top &&
                    window.pageYOffset + clidEl.height() <
                        parEl.offset().top + parEl.height()
                ) {
                    fixEl.css({
                        position: 'fixed',
                        left: leftPos != 0 ? leftPos : 61,
                        top: topPos,
                        width: elWidth
                    })
                } else if (window.pageYOffset < parEl.offset().top) {
                    fixEl.css({
                        position: 'static',
                        top: topPos,
                        width: 'auto'
                    })
                } else {
                    fixEl.css({
                        top:
                            topPos +
                            (window.innerHeight -
                                clidEl.height() -
                                $('footer').height() -
                                40)
                    })
                }
            } else {
                fixEl.css({ position: 'static', width: '100%' })
            }

            // console.log(e);
        })

        ////

        // Паралакс
        if ($('main').hasClass('project1')) {
            $(window).on('scroll', function (e) {
                if ($(window).width() > 1140) {
                    var docc = $(document).scrollTop()
                    var bobles = $('.project-main__sect_parall')
                    var boblesOff = $('.project-main__sect_parall').offset().top

                    if (
                        docc > boblesOff - 2000 &&
                        docc <
                            boblesOff + $('.project-main__sect_parall').height()
                    ) {
                        // var transf = ((docc - boblesOff) / bobles.height()) * 100;
                        var transf = (docc - boblesOff) / 30
                        transf < -35 ? (transf = -35) : transf

                        $('.bobles').css(
                            'transform',
                            'translateY(' + transf * 3 + 'px)'
                        )
                    }
                } else {
                    $('.bobles').removeAttr('style')
                }
            })
        }

        $(document).ready(function () {
            var windowHeight = $(window).height()

            $(document).on('scroll', function () {
                $('.project-main__lamp').each(function () {
                    var self = $(this),
                        height = self.offset().top + self.height() / 1.5
                    // console.log(height);
                    // console.log($(document).scrollTop() + windowHeight);

                    if ($(document).scrollTop() + windowHeight >= height) {
                        setTimeout(function () {
                            self.addClass('project-main__lamp_light')
                        }, 200)
                    }
                })

                $('.project-main__video').each(function () {
                    var self = $(this),
                        height = self.offset().top + self.height(),
                        scrollTop = $(document).scrollTop()
                    if (
                        scrollTop + windowHeight >= height &&
                        height >= scrollTop
                    ) {
                        self.addClass('project-main__video_play')
                        self.find('video').get(0).play()
                    } else {
                        self.removeClass('project-main__video_play')
                        self.find('video').get(0).pause()
                    }
                })

                $('.project-main__car').each(function () {
                    var self = $(this),
                        height = self.offset().top + self.height() / 1.5
                    // console.log(height);
                    // console.log($(document).scrollTop() + windowHeight);

                    if ($(document).scrollTop() + windowHeight >= height) {
                        setTimeout(function () {
                            self.addClass('project-main__car-move')
                        }, 200)
                    }
                })

                $('.project-main__video-mob').each(function () {
                    var self = $(this),
                        height = self.offset().top + self.height(),
                        scrollTop = $(document).scrollTop() + 100
                    if (
                        scrollTop + windowHeight >= height &&
                        height >= scrollTop
                    ) {
                        self.addClass('active')
                        self.find('video').get(0).play()
                    } else {
                        self.removeClass('active')
                        self.find('video').get(0).pause()
                    }
                })
            })
        })

        $('.project-main__video .video-play').on('click', function (e) {
            e.preventDefault()
            $('.project-main__video').addClass('project-main__video_play')
            var video = document.querySelectorAll(
                '.project-main__video video'
            )[0]
            video.play()
            // $('.project-main__video video').play();
        })

        // $(window).on('load', function (e) {
        $('.project-main__left-soc-fix')
            .parent()
            .height($('.project-main__left-soc-fix').outerHeight())
        // });

        $(document).on('scroll', function (e) {
            var fixElem = $('.project-main__left-soc-fix')
            var fixElemParentOff = $('.project-main__left-soc').offset().top
            // fixElem.parent().height(fixElem.outerHeight());
            $('.header')
                .find('.wow')
                .removeClass('wow')
                .css('visibility', 'visible')

            if ($(window).width() < 1366) {
                // console.log(fixElem);

                if ($(window).scrollTop() >= fixElemParentOff) {
                    fixElem.parent().addClass('fixed')
                } else {
                    fixElem.parent().removeClass('fixed')
                }
            }

            // if ($(document).scrollTop() > 0) {
            //     $('.header').addClass('fixed');

            //     var st = $(this).scrollTop();
            //     if (st > scrollPos) {
            //         // down
            //         $('.header').removeClass('fixed-visible');
            //         $('.header').find('.wow').removeClass('wow').css('visibility', 'visible');
            //     } else {
            //         // up
            //         $('.header').addClass('fixed-visible');
            //     }
            //     scrollPos = st;

            // } else {
            //     $('.header').removeClass('fixed');
            // }
        })

        // function trackLocation(e) {

        //     // e.preventDefault();

        //     var rect = videoContainer.getBoundingClientRect(),
        //         position = ((e.pageX - rect.left) / videoContainer.offsetWidth) * 100;
        //     // positionY = ((e.pageY - rect.top) / videoContainer.offsetHeight) * 100;
        //     // console.log(e.pageX);
        //     if (position <= 100) {
        //         videoClipper.style.width = position + 0.2 + "%";
        //         // ukazat.style.left = position + 0.2 + "%"
        //         // ukazat.style.top = positionY + 0.2 + "%"
        //         // clippedVideo.style.width = ((100 / position) * 100) + "%";
        //         // clippedVideo.style.zIndex = 3;
        //     }
        // }
        // var videoContainer = document.getElementById("twocont"),
        //     videoClipper = document.getElementById("twotwo");
        // // ukazat = document.getElementById("ukaz");
        // videoContainer.addEventListener("mousemove", trackLocation, false);
        // videoContainer.addEventListener("touchstart", trackLocation, false);
        // videoContainer.addEventListener("touchend", trackLocation, false);
        // videoContainer.addEventListener("touchmove", trackLocation, false);
        // videoContainer.addEventListener("click", trackLocation, false);

        // $(window).on('load resize', function (e) {

        //     var widt = $('#twocont').width();

        //     // console.log(widt);
        //     $('#twocont img').css('width', widt + 2);
        // });

        // jQuery('body').swipe({
        //     swipeStatus: function (event, phase, direction, distance, duration, fingerCount, fingerData, currentDirection) {
        //         console.log(phase);
        //     }
        // });
    }

    if ($('main').hasClass('project3')) {
        var swiper1 = {
            width: Infinity,
            swiperContainer: '.project-main__sliders-1',
            swiperContainerSlide: '.project-main__sliders-1 img',
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 'auto',
                speed: 15000,
                watchOverflow: true,
                spaceBetween: 46,
                loop: true,
                loopedSlides: 6,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                }
            }
        }

        var swiper2 = {
            width: Infinity,
            swiperContainer: '.project-main__sliders-2',
            swiperContainerSlide: '.project-main__sliders-2 img',
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 'auto',
                speed: 18000,
                watchOverflow: true,
                spaceBetween: 44,
                loop: true,
                loopedSlides: 7,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                }
            }
        }

        var swiper3 = {
            width: Infinity,
            swiperContainer: '.project-main__sliders-3',
            swiperContainerSlide: '.project-main__sliders-3 img',
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 'auto',
                speed: 15000,
                watchOverflow: true,
                spaceBetween: 46,
                loop: true,
                loopedSlides: 27,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                }
            }
        }

        var swiper4 = {
            width: Infinity,
            swiperContainer: '.project-main__sliders-4',
            swiperContainerSlide: '.project-main__sliders-4 img',
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 'auto',
                speed: 18000,
                watchOverflow: true,
                spaceBetween: 44,
                loop: true,
                loopedSlides: 22,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                }
            }
        }

        var swiper5 = {
            width: Infinity,
            swiperContainer: '.project-main__sliders-5',
            swiperContainerSlide: '.project-main__sliders-5 img',
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 'auto',
                speed: 12000,
                watchOverflow: true,
                spaceBetween: 28,
                loop: true,
                loopedSlides: 22,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                }
            }
        }

        var swiper6 = {
            width: Infinity,
            swiperContainer: '.project-main__sliders-6',
            swiperContainerSlide: '.project-main__sliders-6 img',
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 'auto',
                speed: 15000,
                watchOverflow: true,
                spaceBetween: 32,
                loop: true,
                loopedSlides: 23,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                }
            }
        }

        initCustomSwiper(swiper1)
        initCustomSwiper(swiper2)
        initCustomSwiper(swiper3)
        initCustomSwiper(swiper4)
        initCustomSwiper(swiper5)
        initCustomSwiper(swiper6)
        $(window).resize(function () {
            initCustomSwiper(swiper1)
            initCustomSwiper(swiper2)
            initCustomSwiper(swiper3)
            initCustomSwiper(swiper4)
            initCustomSwiper(swiper5)
            initCustomSwiper(swiper6)
        })
    }

    // Направление скролла
    //  if (docc > lastPos) {
    //      console.log('vnizzzz');
    //      transf = transf + 2;
    //  } else {
    //      console.log('vverh');
    //      transf = transf - 2;
    //  }

    $('.project-main__video-mob').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active').find('video').get(0).pause()
        } else {
            $(this).addClass('active').find('video').get(0).play()
        }
    })

    // var playBtn = document.querySelector('.project-main__video-mob .play');
    // var videoEl = document.querySelector('.project-main__video-mob video');

    // playBtn.addEventListener('click', function () {
    //     if (videoEl.paused) {  // если видео остановлено, запускаем
    //         videoEl.play();
    //     } else {
    //         videoEl.pause();
    //     }
    // }, false);
    if ($('main').hasClass('project5')) {
        $(window).on('scroll', function (e) {
            if ($(window).width() > 1140) {
                var doccs = $(document).scrollTop()
                var decorLine = $('.project5-adaptiv__block')
                var decorLineOff = $('.project5-adaptiv__block').offset().top
                var aboutUs5 = $('.project5-sect__aboutUs')
                var aboutUs5Off = $('.project5-sect__aboutUs').offset().top
                var font5 = $('.project5-sect__font')
                var font5Off = $('.project5-sect__font').offset().top
                var screens5 = $('.project5-sect__screens')
                var screens5Off = $('.project5-sect__screens').offset().top

                if (
                    doccs > decorLineOff - 2000 &&
                    doccs <
                        decorLineOff + $('.project5-adaptiv__block').height()
                ) {
                    var transf = (doccs - decorLineOff) / 30
                    transf < -35 ? (transf = -35) : transf

                    $('.project5-adaptiv__decor-line').css(
                        'transform',
                        'translateY(' + transf * 3 + 'px)'
                    )
                }
                if (
                    doccs > aboutUs5Off - 2000 &&
                    doccs < aboutUs5Off + aboutUs5.height()
                ) {
                    var transf = (doccs - aboutUs5Off) / 30
                    transf < -35 ? (transf = -35) : transf

                    $('.pixel').css(
                        'transform',
                        'translateY(' + transf * 3 + 'px)'
                    )
                }
                if (
                    doccs > font5Off - 2000 &&
                    doccs < font5Off + font5.height()
                ) {
                    var transf = (doccs - font5Off) / 30
                    transf < -35 ? (transf = -35) : transf

                    $('.pixel').css(
                        'transform',
                        'translateY(' + transf * 3 + 'px)'
                    )
                }
                if (
                    doccs > screens5Off - 2000 &&
                    doccs < screens5Off + screens5.height()
                ) {
                    var transf = (doccs - screens5Off) / 30
                    transf < -35 ? (transf = -35) : transf

                    $('.pixel').css(
                        'transform',
                        'translateY(' + transf * 3 + 'px)'
                    )
                }
            } else {
                $('.project5-adaptiv__decor-line').removeAttr('style')
                $('.pixel').css('transform', 'translateY(' + transf * 3 + 'px)')
            }
        })
    }

    if ($('main').hasClass('project6')) {
        var project6swiper = {
            width: Infinity,
            swiperContainer: '.project6-sliders',
            swiperContainerSlide: '.project6-sliders img',
            // swiperVariable: undefined,
            // swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: 4,
                speed: 15000,
                watchOverflow: true,
                // spaceBetween: 146,
                loop: true,
                loopedSlides: 4,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false
                }
            }
        }

        initCustomSwiper(project6swiper)
        $(window).resize(function () {
            initCustomSwiper(project6swiper)
        })
    }
    if ($('main').hasClass('project6')) {
        $(window).on('scroll', function (e) {
            if ($(window).width() > 1140) {
                var doccs = $(document).scrollTop()
                var decorBall = $('.project6-sect__aboutUs .ball')
                var aboutUsImg = $('.project6-aboutUs__img')
                var aboutUs6 = $('.project6-sect__aboutUs')
                var aboutUs6Off = $('.project6-sect__aboutUs').offset().top
                var mainPage6 = $('.project6-sect__mainPage')
                var mainPageBall6 = $('.project6-mainPage__ball')
                var mainPage6Off = $('.project6-sect__mainPage').offset().top

                if (
                    doccs > aboutUs6Off - 2000 &&
                    doccs < aboutUs6Off + aboutUs6.height()
                ) {
                    var transf = (doccs - aboutUs6Off) / 30
                    transf < -35 ? (transf = -5) : transf
                    aboutUsImg.css(
                        'transform',
                        'translateY(' + transf * 3 + 'px)'
                    )
                    decorBall.css(
                        'transform',
                        'translateY(' + transf * 3 + 'px)'
                    )
                }
            } else {
                decorBall.css('transform', 'translateY(' + transf * 3 + 'px)')
                aboutUsImg.css('transform', 'translateY(' + transf * 3 + 'px)')
            }
        })
    }
})

// function setCSSVarVH() {
//     let vh = window.innerHeight * 0.01;
//     document.documentElement.style.setProperty('--vh', `${vh}px`);
// }
// setCSSVarVH();

if (document.querySelector('.project6')) {
    const tl = gsap.timeline({ defaults: { duration: 0.7 } })
    if (document.querySelector('.project-hero__block')) {
        tl.from('.project6-animation1', { opacity: 0, x: -50, delay: 0.3 })
            .from('.project6-animation2', { opacity: 0, x: 50, delay: 0.3 })
            .from('.project6-animation3', { opacity: 0, x: -50, delay: 0.3 })
            .from('.project6-animation2', { rotate: -6, delay: 0.3 })
    }
    gsap.from('.project6-illustrations__item', {
        scale: 0,
        opacity: 0.1,
        delay: 0.3,
        duration: 1,
        // ease: "power1.inOut",
        scrollTrigger: {
            trigger: '.project6-illustrations__item'
            // start: "bottom",
        },
        stagger: {
            from: 'center',
            amount: 1.5
        }
    })
    // gsap.from(".project6-sect__desktop", {

    // })
}
